<template>
  <div>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        >
        </v-skeleton-loader>
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th">Follow Up Date</th>
                <th class="simple-table-th">Remark</th>
                <th class="simple-table-th">Type</th>
                <th class="simple-table-th">Next Follow Up Date</th>
                <th class="simple-table-th">Created Date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(followup, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td class="font-size-14 font-weight-500 text-capitalize">
                  {{ formatDate(followup.follow_up_date) }}
                </td>
                <td class="font-size-14 font-weight-500 text-capitalize">
                  {{ followup.remark }}
                </td>

                <td class="font-size-14 font-weight-500 text-capitalize">
                  {{ followup.type }}
                </td>
                <td class="font-size-14 font-weight-500 text-capitalize">
                  <template v-if="followup && followup.next_follow_up_date">
                    {{ formatDate(followup.next_follow_up_date) }}
                  </template>
                  <em v-else class="text-muted"> no next follow up</em>
                </td>
                <td class="font-size-14 font-weight-500 text-capitalize">
                  {{ formatDateTime(followup.added_at) }}
                </td>
              </tr>

              <tr v-if="rowData.length === 0">
                <td colspan="9" class="text-center py-4">
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  <em class="text-muted">
                    Uhh... There are no file at the moment.</em
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
export default {
  name: "opportunities",
  title: "Lead",
  mixins: [CommonMixin],
  props: {
    opportunity: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
    };
  },

  watch: {
    opportunity: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },
  methods: {
    /**
     * Emit the opportunity id so parent can open edit page.
     * Accepts either opportunity object or id.
     */

    assignData() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.opportunity.follow_ups) === false) {
        _this.rowData = _this.opportunity.follow_ups;
      }
    },
  },
  mounted() {
    const _this = this;
    _this.assignData();
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
};
</script>
